import React from 'react'
import Button from '@packages/justo-parts/lib/components/Button/withoutLink'

const WrappedButton = React.forwardRef<any, any>((props, ref) => <Button {...props} ref={ref} />)

WrappedButton.displayName = 'WrappedButton'

export default WrappedButton
